import { env } from '@gitbook/env';

const GB_TEST_FLAGS_SESSION_STORAGE_KEY = 'gitbook_test_flags';

/**
 * Return feature flag overrides from sessionStorage.
 *
 * This is for testing purposes and is only active in the test environment.
 * It allows to set feature flags in e2e tests.
 *
 * The flags passed to the login function are persisted to sessionStorage before any app JavaScript
 * runs. All other flags are disabled.
 * Flags must be set in each test as tests run in different browser contexts, so flags set in one test won't leak to another test.
 */
export function getFeatureFlagTestOverrides(): string[] {
    if (env !== 'test') {
        return [];
    }

    let flags: string[] = [];

    try {
        const stored = sessionStorage.getItem(GB_TEST_FLAGS_SESSION_STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
                flags = parsed.filter((flag): flag is string => typeof flag === 'string');
            }
        }
    } catch {
        // Ignore sessionStorage errors
    }

    return flags;
}
